import { RemoveAllModal} from "./RemoveAllModal";

export default RemoveAllModal;
